const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;

const startOfDay = (date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate());

/** Short relative time: "Just now", "12m ago", "2h ago", "Yesterday", "3d ago", "2w ago". */
export function timeAgo(timestamp, now = new Date()) {
  const date = new Date(timestamp);

  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const diff = now - date;

  if (diff < MINUTE) {
    return 'Just now';
  }

  if (diff < HOUR) {
    return `${Math.floor(diff / MINUTE)}m ago`;
  }

  if (startOfDay(date).getTime() === startOfDay(now).getTime()) {
    return `${Math.floor(diff / HOUR)}h ago`;
  }

  const days = Math.round((startOfDay(now) - startOfDay(date)) / DAY);

  if (days === 1) {
    return 'Yesterday';
  }

  if (days < 7) {
    return `${days}d ago`;
  }

  return `${Math.floor(days / 7)}w ago`;
}

export const GROUPS = ['Today', 'Earlier this week', 'Older'];

export function groupLabel(timestamp, now = new Date()) {
  const date = new Date(timestamp);

  if (startOfDay(date).getTime() === startOfDay(now).getTime()) {
    return GROUPS[0];
  }

  return now - date < WEEK ? GROUPS[1] : GROUPS[2];
}
